import {fetchParam, loadingClass} from "../settings/settings";
import {showAjaxCallbackMessage} from "./ajaxCallback";

const $buttonRecoverBankroll = document.getElementById("js-button-recover-bankroll");

if ($buttonRecoverBankroll) {
  const $modalRecoverBankroll = $("#js-modal-recover-bankroll");

  const recoverBankroll = () => {
    return fetch($buttonRecoverBankroll.getAttribute('data-url'), fetchParam);
  };

  const clearBankrollPrice = () => {
    const $bankrollPrice = document.getElementById("js-bankroll-price");
    const defaultValue = $bankrollPrice.getAttribute("data-default-value");
    $bankrollPrice.innerHTML = defaultValue;
    document.querySelector("#js-bankroll-price").parentElement.querySelector('button').setAttribute('disabled', null);
  };

  const showBankrollModal = () => $modalRecoverBankroll.foundation("open");


  $buttonRecoverBankroll.addEventListener("click", event => {
    const $loader = document.querySelector(".js-loader");

    $loader.classList.add(loadingClass);

    recoverBankroll()
      .then((response) => {
        if (!response.ok) {
          return response.json().then(response => Promise.reject(response));
        }
      })
      .then((response) => {
        showBankrollModal();

        setTimeout(() => clearBankrollPrice(), 500);
      })
      .catch(error => showAjaxCallbackMessage(error))
      .finally(() => $loader.classList.remove(loadingClass));

  });
}
